// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
//import { getFirestore } from "firebase/firestore";
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBc9saYJjGOzPzbNGceyf8lEGFNApu_XCM",
  authDomain: "mockquest.firebaseapp.com",
  projectId: "mockquest",
  storageBucket: "mockquest.appspot.com",
  messagingSenderId: "487973824745",
  appId: "1:487973824745:web:6b2921abaec0116dbc2878",
  measurementId: "G-F127DEBH5G",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { app, auth };


